import TxtViewer from './TxtViewer';

export default TxtViewer;
